export const noOpAction = () => ({
  type: '@@NOOP'
});